<template>
  <div class="viagens-wrapper">
    <v-container class="py-16">
      
      <div class="text-center mb-10">
        <h2 class="text-overline red--text font-weight-bold tracking-widest mb-2">
          AGENDA ABERTA
        </h2>
        <h1 class="text-h4 text-md-h2 white--text font-weight-black text-uppercase">
          Próximas Expedições
        </h1>
        <div class="mx-auto mt-4 gradient-line"></div>
        <p class="grey--text text--lighten-1 mt-6 mx-auto" style="max-width: 700px; font-size: 1.1rem;">
          Garanta sua vaga nas próximas aventuras e faça parte da nossa história.
        </p>
      </div>

      <div v-if="loading" class="text-center py-10">
        <v-progress-circular indeterminate color="#D32F2F" size="60"></v-progress-circular>
      </div>

      <div v-else-if="expedicoes.length === 0" class="text-center py-10 mb-16">
         <p class="grey--text text-h6">Em breve divulgaremos novas datas.</p>
      </div>

      <v-row v-else class="mb-16" justify="center">
        <v-col 
          v-for="exp in expedicoes" :key="exp.id"
          cols="12" md="4"
          class="d-flex"
        >
          <v-hover v-slot="{ hover }">
            <v-card 
              class="course-card rounded-xl flex-grow-1 d-flex flex-column"
              :elevation="hover ? 24 : 6"
              color="#1a1a1a"
              :class="{ 'on-hover': hover }"
              @click="abrirDetalhesExpedicao(exp)"
            >
              <div class="image-wrapper rounded-t-xl">
                <v-img 
                  :src="exp.volume && exp.volume[0] ? exp.volume[0].url : 'https://via.placeholder.com/400'" 
                  height="250px" 
                  cover
                  class="zoom-image"
                  :class="{ 'zoomed': hover }"
                >
                  <div class="d-flex justify-end pa-4">
                      <v-chip 
                        color="red darken-1" 
                        label 
                        class="font-weight-bold white--text elevation-4"
                      >
                        <v-icon left small>mdi-calendar</v-icon>
                        {{ formataData(exp.dataInicio) }}
                      </v-chip>
                  </div>
                  <div class="image-gradient"></div>
                </v-img>
              </div>

              <div class="d-flex flex-column flex-grow-1 pa-6 relative z-index-2">
                <h3 class="text-h5 font-weight-bold white--text mb-2">
                  {{ exp.local }}
                </h3>
                
                <p class="grey--text text--lighten-1 flex-grow-1 text-body-2 line-clamp-3">
                  {{ truncateText(exp.descricao, 120) }}
                </p>

                <v-divider class="grey darken-3 my-4"></v-divider>

                <div class="d-flex align-center justify-end mt-auto">
                  <v-btn 
                    :color="hover ? 'red darken-1' : 'white'" 
                    :outlined="!hover"
                    :dark="hover"
                    rounded
                    class="px-8 font-weight-bold transition-swing"
                    @click.stop="abrirDetalhesExpedicao(exp)"
                  >
                    SAIBA MAIS
                    <v-icon right small>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-divider class="grey darken-3 mb-16"></v-divider>

      <div class="text-center mb-16">
        <h2 class="text-overline red--text font-weight-bold tracking-widest mb-2">
          NOSSO PORTFÓLIO
        </h2>
        <h1 class="text-h4 text-md-h2 white--text font-weight-black text-uppercase">
          Lagão pelo Mundo
        </h1>
        <div class="mx-auto mt-4 gradient-line"></div>
        <p class="grey--text text--lighten-1 mt-6 mx-auto" style="max-width: 700px; font-size: 1.1rem;">
          Confira os registros das expedições incríveis que já realizamos. Cada viagem é uma história única.
        </p>
      </div>

      <div v-if="!loading && viagens.length === 0" class="text-center py-10">
        <v-icon size="60" color="grey darken-3">mdi-image-filter-hdr</v-icon>
        <p class="grey--text mt-4">Nenhuma viagem registrada no histórico ainda.</p>
      </div>

      <v-row v-else>
        <v-col 
          v-for="viagem in viagens" 
          :key="viagem.id"
          cols="12" sm="6" md="4"
        >
          <CardViagens :viagem="viagem" @abrir-detalhes="abrirDetalhesViagem" />
        </v-col>
      </v-row>

      <v-dialog v-model="dialogDetalhes" max-width="900px" scrollable>
        <v-card v-if="itemSelecionado" color="#1E1E1E" class="rounded-xl overflow-hidden">
          
          <v-toolbar color="transparent" flat class="pt-2 px-2">
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogDetalhes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-0">
            <v-container>
              <v-row>
                <v-col cols="12" class="text-center mb-6">
                  <div class="d-flex justify-center align-center mb-2">
                    <v-icon color="#D32F2F" class="mr-2">mdi-map-marker</v-icon>
                    <span class="text-overline grey--text text--lighten-1 tracking-widest">
                      {{ formataData(itemSelecionado.dataInicio || itemSelecionado.inicioViagem) }}
                    </span>
                  </div>
                  
                  <h2 class="text-h3 font-weight-black white--text text-uppercase mb-4">
                    {{ itemSelecionado.local || itemSelecionado.destino }}
                  </h2>
                  
                  <div class="mx-auto gradient-line mb-6"></div>
                  
                  <p class="grey--text text--lighten-1 text-body-1" style="max-width: 800px; margin: 0 auto; line-height: 1.8;">
                    {{ itemSelecionado.descricao }}
                  </p>

                  <div v-if="ehExpedicao(itemSelecionado)" class="mt-8">
    <v-btn
        rounded
        large
        color="green darken-1"
        class="px-8 font-weight-bold white--text elevation-6"
        @click="abrirWhatsapp(itemSelecionado)"
    >
        <v-icon left>mdi-whatsapp</v-icon>
        {{ itemSelecionado.textoBotao || 'GARANTIR MINHA VAGA' }}
    </v-btn>
</div>
                </v-col>

                <v-col cols="12">
                  <h3 class="text-h5 white--text font-weight-bold mb-4 ml-2 border-left-red pl-4">
                    Galeria de Fotos
                  </h3>
                  
                  <div v-if="!temFotos(itemSelecionado)" class="text-center py-10 grey--text darken-2">
                    <v-icon size="40" color="grey darken-3">mdi-camera-off</v-icon>
                    <p class="mt-2">Nenhuma foto disponível.</p>
                  </div>

                  <v-row v-else>
                     <v-col 
                        v-for="(foto, i) in itemSelecionado.volume" 
                        :key="i"
                        cols="12" sm="6" md="4"
                     >
                        <v-card 
                          class="rounded-lg overflow-hidden photo-card" 
                          hover
                          @click="abrirFotoGrande(i)"
                        >
                          <v-img 
                            :src="foto.url" 
                            aspect-ratio="1.5" 
                            cover
                            class="zoom-hover"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="#D32F2F"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                     </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="justify-center pb-6">
            <v-btn 
              rounded 
              large 
              color="#D32F2F" 
              dark 
              class="px-8 font-weight-bold"
              @click="dialogDetalhes = false"
            >
              Fechar Detalhes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFoto" fullscreen hide-overlay transition="fade-transition">
        <v-card color="black" dark class="d-flex flex-column justify-center align-center">
          <v-btn icon absolute top right large @click="dialogFoto = false" class="mt-4 mr-4 z-index-10">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
          <v-carousel 
            v-if="itemSelecionado && temFotos(itemSelecionado)"
            v-model="fotoIndex"
            hide-delimiters
            height="100%"
            style="width: 100%;"
          >
            <v-carousel-item
              v-for="(foto, i) in itemSelecionado.volume"
              :key="i"
              :src="foto.url"
              contain
            ></v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import ViagensService from '@/services/viagens.service';
import ExpedicoesService from '@/services/expedicoes.service'; 
import CardViagens from './CardViagens.vue';

export default {
  name: "ListaViagens",
  components: {
    CardViagens
  },
  data() {
    return {
      viagens: [],
      expedicoes: [],
      loading: true,

      // Controle do Modal de Detalhes
      dialogDetalhes: false,
      itemSelecionado: null, // Genérico para aceitar Viagem ou Expedição

      // Controle do Lightbox (Foto Cheia)
      dialogFoto: false,
      fotoIndex: 0
    };
  },
  methods: {
    abrirWhatsapp(expedicao) {
      const numero = "61998385830";
      // Verifica se é local ou destino para montar a mensagem
      const nomeLocal = expedicao.local || expedicao.destino;
      const mensagem = `Olá, desejo mais informações a respeito da expedição *${nomeLocal}*`;
      const url = `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(mensagem)}`;
      window.open(url, '_blank');
    },
    
    // Formata Data
    formataData(data) {
        if(!data) return '';
        const date = new Date(data);
        return date.toLocaleDateString('pt-BR');
    },
    
    truncateText(text, length) {
      if (!text || typeof text !== 'string') return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + '...';
    },

    // --- MÉTODOS DO MODAL ---
    
    // Chamado pelos cards do Portfólio
    abrirDetalhesViagem(viagem) {
      this.itemSelecionado = viagem;
      this.dialogDetalhes = true;
    },

    // Chamado pelos cards de Expedição (NOVO)
    abrirDetalhesExpedicao(expedicao) {
      this.itemSelecionado = expedicao;
      this.dialogDetalhes = true;
    },

    // Helper para saber se o item atual é uma expedição (tem 'local') ou viagem
    ehExpedicao(item) {
        return item && !!item.local; 
    },
    
    temFotos(item) {
      return item && item.volume && Array.isArray(item.volume) && item.volume.length > 0;
    },

    abrirFotoGrande(index) {
      this.fotoIndex = index;
      this.dialogFoto = true;
    }
  },
  async mounted() {
    this.loading = true;
    try {
      // Carrega Viagens (Portfólio) e Expedições (Agenda)
      const [viagensRes, expedicoesRes] = await Promise.all([
          ViagensService.getAll(),
          ExpedicoesService.getAll()
      ]);

      // Processa Viagens
      this.viagens = viagensRes.data || [];
      this.viagens.sort((a, b) => new Date(b.inicioViagem) - new Date(a.inicioViagem));

      // Processa Expedições
      this.expedicoes = expedicoesRes.data || [];

    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.viagens-wrapper {
  background-color: #121212;
  min-height: 100vh;
}
.tracking-widest {
  letter-spacing: 3px !important;
}
.gradient-line {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #D32F2F 0%, #ff7961 100%);
  border-radius: 4px;
}

/* --- ESTILOS DOS CARDS DE EXPEDIÇÃO --- */
.course-card {
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  background: #1a1a1a;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  overflow: hidden;
}

.course-card.on-hover {
  transform: translateY(-12px);
  border-color: #D32F2F !important;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5) !important;
}

.image-wrapper {
  position: relative;
  overflow: hidden;
  height: 250px;
}

.zoom-image { transition: transform 0.6s ease; }
.zoom-image.zoomed { transform: scale(1.1); }

.image-gradient {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.9) 100%);
  pointer-events: none;
}

/* Utilitários de Texto */
.line-clamp-3 {
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;
}
.transition-swing {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

/* --- ESTILOS EXTRAS PARA O MODAL --- */
.border-left-red {
  border-left: 4px solid #D32F2F;
}
.photo-card {
  border: 1px solid rgba(255,255,255,0.1);
  cursor: pointer;
}
.zoom-hover {
  transition: transform 0.4s ease;
}
.photo-card:hover .zoom-hover {
  transform: scale(1.05);
}
.z-index-10 {
  z-index: 10;
}
</style>